/**
 * @module CategoryPreview
 */

import Component from '../base/Component';
import './styles.css';

import '../../images/sprite/diagnostic.svg';

/**
 * Название компонента.
 */
export default class CategoryPreview extends Component {
    static className = 'category-preview';
}
